import React from "react";

import * as styles from "./TestStyle.module.css";

type TestDataEntryProps = Readonly<{
  header: string;
  text: string;
}>;

export const TestDataEntry = ({ header, text }: TestDataEntryProps) => (
  <div className={styles.row}>
    <div className={styles.header}>{header}</div>
    <div className={styles.dataEntryValue}>{text}</div>
  </div>
);
